<template>
  <div class="sucursales-sidebar-list">
    <div class="d-flex align-center mb-4 px-1">
      <v-icon x-small color="blue" class="mr-2">mdi-home-group</v-icon>
      <span class="text-overline grey--text text--lighten-1 font-weight-black letter-spacing-1">
        Sucursales
      </span>
      <v-spacer></v-spacer>
      <v-progress-circular v-if="loading" indeterminate size="12" width="2" color="blue"></v-progress-circular>
    </div>

    <v-fade-transition group vertical>
      <div
        v-for="sucursal in sucursales"
        :key="sucursal.id"
        @click="emitSeleccion(sucursal)"
        class="sucursal-item-list pa-3 mb-2 rounded-lg d-flex align-center cursor-pointer transition-all"
      >
        <v-avatar size="32" color="rgba(33, 150, 243, 0.1)" class="mr-3 border-blue-thin">
          <v-icon x-small color="blue lighten-1">mdi-store</v-icon>
        </v-avatar>

        <div class="overflow-hidden">
          <div class="white--text text-caption font-weight-bold text-truncate line-height-tight">
            {{ sucursal.nombre }}
          </div>
          <div class="grey--text" style="font-size: 0.65rem">
            {{ sucursal.direccion || 'Sin dirección' }}
          </div>
        </div>

        <v-spacer></v-spacer>
        
        <v-icon x-small color="grey darken-3" class="arrow-icon">mdi-chevron-right</v-icon>
      </div>
    </v-fade-transition>

    <div v-if="!loading && sucursales.length === 0" class="text-center pa-4 grey--text text-caption border-subtle rounded-lg">
      No hay terminales activas
    </div>
  </div>
</template>

<script>
export default {
  name: "SucursalListCard",
  props: {
    autoFetch: { type: Boolean, default: true },
  },
  data: () => ({
    sucursales: [],
    loading: false,
  }),
  methods: {
    emitSeleccion(sucursal) {
      this.$emit("seleccionar", sucursal);
    },
    async fetchSucursales() {
      this.loading = true;
      try {
        const response = await this.axios.get("/sucursales/sucursales");
        this.sucursales = response.data;
      } catch (err) {
        console.error("Error al cargar sucursales", err);
      } finally {
        this.loading = false;
      }
    },
  },
  created() {
    if (this.autoFetch) this.fetchSucursales();
  },
};
</script>

<style scoped>
.sucursal-item-list {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.03);
}

.sucursal-item-list:hover {
  background: rgba(33, 150, 243, 0.08);
  border-color: rgba(33, 150, 243, 0.2) !important;
}

.sucursal-item-list:hover .arrow-icon {
  color: #2196f3 !important;
  transform: translateX(3px);
}

.border-blue-thin {
  border: 1px solid rgba(33, 150, 243, 0.2);
}

.transition-all {
  transition: all 0.25s ease;
}

.line-height-tight {
  line-height: 1.2;
}

.arrow-icon {
  transition: all 0.2s ease;
}
</style>